import React, { useState } from 'react';
import { GIButton } from 'app-components';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { ResendDropdownProps } from '../types/selfDesignationOtpTypes';

const DropdownContainer = styled.div`
    position: relative;
    display: inline-block;
    button {
        outline: none !important;
    }
`;

const DropdownMenu = styled.div<{ isOpen: boolean }>`
    display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #f1f1f1;
    min-width: max-content;
    border-radius: 4px;
`;

const DropdownItem = styled.a`
    padding: 6px 16px;
    text-decoration: none;
    display: block;

    &:hover {
        background-color: #ddd;
    }
`;

const ResendDropdown: React.FC<ResendDropdownProps> = ({ title, resendConfig, callback, isDisabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <DropdownContainer>
            <GIButton
                id="areYouSureModalContinueButton"
                labelId={title}
                variant="link"
                onClickHandler={toggleDropdown}
                isDisabled={isDisabled}
            />
            <DropdownMenu isOpen={isOpen}>
                {resendConfig.map((item, index) => (
                    <ConditionalRendering isTrue={item.visible} key={`rense-button-${index}`}>
                        <DropdownItem
                            key={`rense-button-${index}`}
                            onClick={() => {
                                toggleDropdown();
                                callback(item.key);
                            }}
                        >
                            <FormattedMessage id={item.label} />
                        </DropdownItem>
                    </ConditionalRendering>
                ))}
            </DropdownMenu>
        </DropdownContainer>
    );
};

export default ResendDropdown;
